import React, { Component } from 'react';
import { Link } from 'react-router-dom';


export class Sidebar6 extends Component {
    render() {
        return (
            <div>
                <div className="widget widget-nav-menu">
                    <ul className="widget-menu">
                        <li><Link activeClassName="active" to={process.env.PUBLIC_URL + '/marketing-automation'}>Marketing Automation</Link></li>
                        <li><Link activeClassName="active" to={process.env.PUBLIC_URL + '/buyer-journey-management'}>Buyer Journey Management</Link></li>
                        <li><Link activeClassName="active" to={process.env.PUBLIC_URL + '/salesforce-integration-orchestration'}>Integration Orchestration</Link></li>
                        <li><Link to={process.env.PUBLIC_URL + '/business-process-management'}>Business Process Management</Link></li>
                        <li><Link to={process.env.PUBLIC_URL + '/business-process-audits'}>Business Process Audits</Link></li>
                        <li><Link to={process.env.PUBLIC_URL + '/bi-dashboarding'}>BI – Dashboarding</Link></li>
                        <li><Link to={process.env.PUBLIC_URL + '/it-infrastructure-management'}>IT-Infrastructure Management</Link></li>
                        <li><Link to={process.env.PUBLIC_URL + '/managed-services-support-on-salesforce'}>Managed Services</Link></li>
                        <li><Link to={process.env.PUBLIC_URL + '/carve-outs-and-org-integrations'}>Carve Outs and Org Integrations</Link></li>
                        <li><Link to={process.env.PUBLIC_URL + '/gen-ai-and-agentic-ai'}>Gen-AI and Agentic AI</Link></li>
                        <li><Link to={process.env.PUBLIC_URL + '/platform-devon-fullstack-technologies'}>Platform Dev on Full Stack Technologies</Link></li>
                        <li><Link to={process.env.PUBLIC_URL + '/saleforce-optimization-services'}>Saleforce Optimization</Link></li>
                    </ul>
                </div>
            </div>
        );
    }
}

export default Sidebar6;